<div class="send-dialog">
  <div class="ui-g-12 p-zero dialog-header m-0 d-flex align-items-center">
    <i class="far fa-paper-plane font-20 font-gray-45 header-icon"></i>
    <div class="send-dialog-heading capitalize" *ngIf="!isEstimateDeposit">Send {{ order?.orderStatus }}</div>
    <div class="send-dialog-heading" *ngIf="order?.orderStatus !== 'invoice' && isEstimateDeposit">{{ isResendEstDeposit
      ? 'Re-send' : 'Send' }} {{ order?.orderStatus }} deposit request</div>
    <i class="far fa-times fa-sm dialog-close" (click)="close({})"></i>
  </div>

  <div class="ui-g-12 dialog-body pt-3" #sendDialog>
    <div class="row m-0 p-0">
      <!-- Start Left Panel -->
      <div class="col-12 col-lg-{{ isMarketingEnabled ? '4' : '6' }} p-0">
        <div class="left-box pt-2">
          <div class="input-style-wrapper-icon w-100" [ngClass]="{ 'pb-2': errors.depositAmt }"
            *ngIf="order?.orderStatus !== 'invoice' && isEstimateDeposit">
            <div class="icon-wrapper align-self-center font-14">
              <i class="far fa-usd-circle font-gray-35"></i>
            </div>

            <div class="input-wrapper small">
              <app-input placeholder="Deposit request amount*" id="objective" theme="light" name="depositAmt"
                [allowDecimal]="focus?.depositAmt ? true : false" [fontSize]="14" [floatingLabel]="true"
                [isInvalid]="errors.depositAmt" [errorMessage]="errors.depositAmt"
                [value]="focus.depositAmt ? order?.depositRequest?.amount || '' : depositText" [maxLength]="50"
                (appFocus)="focusInput('depositAmt')" (appBlur)="blurInput($event, 'depositAmt')"
                (appChange)="handleChange('depositAmt', $event)">
              </app-input>
            </div>
          </div>

          <div class="input-style-wrapper-icon w-100" [ngClass]="{ 'mt-30': isEstimateDeposit }">
            <div class="icon-wrapper align-self-center font-14">
              <i class="far fa-user font-gray-35"></i>
            </div>

            <div class="input-wrapper small p-relative">
              <app-input placeholder="Customer*" id="objective" theme="light" [disabled]="true"
                [value]="order?.customer?.displayName" [floatingLabel]="true"> </app-input>
              <ng-container *ngIf="companyLocalization">
                <i *ngIf="isSavingLanguage" class="fal fa-spinner rotate globe-icon"></i>
                <div *ngIf="!isSavingLanguage" class="globe-icon"
                  [ngClass]="{'disabled': this.isSavingLanguage || this.isProcessing}" (click)="switchLanguage()">
                  {{currentLang?.toUpperCase()}}
                  <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
                </div>
              </ng-container>
              <!-- <button class="action action-cancel">
                <a href="[cancel]">Cancel</a>
              </button> -->
            </div>
          </div>



          <div class="input-style-wrapper-icon w-100 mt-30">
            <div class="icon-wrapper align-self-center font-14">
              <i class="far fa-link font-gray-35"></i>
            </div>

            <div class="input-wrapper small">
              <app-input theme="light" placeholder="Subject" id="subject" (appChange)="subjectChange($event)"
                [disabled]="false" [value]="subject" [floatingLabel]="true"> </app-input>
            </div>
          </div>

          <div class="input-style-wrapper-icon w-100 mt-30 full-height-textarea">
            <div class="icon-wrapper align-self-start font-14 mt-2">
              <i class="far fa-file-alt font-gray-35"></i>
            </div>

            <div class="input-wrapper small">
              <span class="fake-small-label"> Message </span>
              <textarea id="content" name="content" placeholder="" rows="5" cols="30" class="primary-theme"
                [value]="content" [(ngModel)]="content"> </textarea>
            </div>
          </div>
        </div>
      </div>
      <!-- End Left Panel -->

      <!-- Start Right Panel -->
      <div class="col-12 col-lg-{{ isMarketingEnabled ? '4' : '6' }} p-0">
        <div class="right-box flex-column pt-0">
          <!-- Contact preferrence -->
          <div class="contact-btn d-flex pr-0">
            <app-outline-icon-btn id="send-dialog-email" class="mr-2" label="Email" icon="far fa-envelope"
              [active]="isEmailSelected && recipients?.emails?.length"
              (handleClick)="toggleActiveState('isEmailSelected', $event)">
            </app-outline-icon-btn>

            <app-outline-icon-btn id="send-dialog-phone" label="SMS" icon="far fa-mobile"
              [active]="isSMSSelected && recipients?.phones?.length"
              (handleClick)="toggleActiveState('isSMSSelected', $event)">
            </app-outline-icon-btn>
          </div>

          <!-- Notification -->
          <div class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
            tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
            [pTooltip]="notificationRecipientTooltip" [escape]="false">
            <i class="far fa-edit pointer p-2 update-recipient-icon" tooltipPosition="top"
              [ngClass]="{ 'not-allowed': !isEmailSelected && !isSMSSelected }"
              [pTooltip]="!isEmailSelected && !isSMSSelected ? 'Select Email or Phone to add Recipients' : ''"
              (click)="openUpdateRecipientDialog('confirmation')"></i>

            <div class="width-100p flex-start-center font-13">
              <i class="far fa-bell font-gray-85 contact-icon flex-center-center"></i>
              <span class="font-bold">Notification</span>
            </div>

            <div class="flex-start-center font-12">
              <i class="far fa-envelope font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="recipients?.emails?.length === 1">
                {{ (recipients?.emails)[0].value }}
              </span>

              <span *ngIf="recipients?.emails?.length !== 1">
                <span *ngIf="!recipients?.emails?.length">No email</span>
                <span *ngIf="recipients?.emails?.length">{{ recipients?.emails?.length }} email addresses</span>
              </span>
            </div>

            <div class="flex-start-center font-12">
              <i class="far fa-mobile font-gray-85 contact-icon flex-center-center"></i>
              <span *ngIf="recipients?.phones?.length === 1">
                {{ (recipients?.phones)[0].value | mask : '(000) 000-0000' }}
              </span>

              <span *ngIf="recipients?.phones?.length !== 1">
                <span *ngIf="!recipients?.phones?.length">No phone</span>
                <span *ngIf="recipients?.phones?.length">{{ recipients?.phones?.length }} mobile numbers</span>
              </span>
            </div>
          </div>

          <!-- show paymetn in pdf payment -->
          <!-- <div class="mt-2 p-0" *ngIf="isShowPaymentInPdf">
            <app-switch-card
              [active]="isShowPaymentDetails"
              [switch]="card.isShowPaymentDetails.switch"
              [heading]="card.isShowPaymentDetails.heading"
              (appChange)="toggleActiveState('isShowPdf', $event)"
            >
            </app-switch-card>
          </div> -->

          <!-- Reminders -->
          <div *ngIf="templateType === 'ESTIMATE' || templateType === 'ESTIMATE_DEPOSIT_REQUEST'" class="mt-2">
            <div class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
              tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
              [pTooltip]="reminderRecipientTooltip" [escape]="false">

              <div class="width-100p flex-between-center">
                <div class="flex-start-center font-13">
                  <i class="fal fa-chevron-right font-gray-85 contact-icon flex-center-center"></i>
                  <span class="font-bold">
                    Authorization Reminder
                    <i *ngIf="unsubscriptionTooltip" class="fal fa-exclamation-triangle font-yellow font-13"
                      tooltipPosition="top" [escape]="false" [pTooltip]="unsubscriptionTooltip"></i>
                  </span>
                </div>

                <app-switch-pill [isActive]="isReminderEnabled && !isReminderDisabled" [disabled]="isReminderDisabled"
                  (appChange)="handleReminderEnableChange($event); toggleActiveState('isReminder', $event)">
                </app-switch-pill>
              </div>

              <div class="flex-row flex-between w-100">
                <div class="flex-center-center">
                  <app-checkbox label="" [disabled]="isSendReminderDisabled" [fontSize]="11"
                    [isChecked]="useConfirmationRecipient && !isSendReminderDisabled"
                    (appChange)="handleUseConfirmationRecipientChange($event); handleSendReminderDisabledChange()">
                  </app-checkbox>

                  <p class="m-0 font-11">Send reminders to same contacts as confirmation</p>
                </div>

                <i class="far fa-edit flex-center-center pointer font-secondary" tooltipPosition="top"
                  [ngClass]="{ 'not-allowed': (!isEmailSelected && !isSMSSelected) || useConfirmationRecipient}"
                  [pTooltip]="!isEmailSelected && !isSMSSelected ? 'Select Email or Phone to add Recipients' : ''"
                  (click)="openUpdateRecipientDialog('reminder')"></i>
              </div>

              <div class="flex-start-center font-12">
                <i class="far fa-envelope font-gray-85 contact-icon flex-center-center"></i>
                <span *ngIf="reminderRecipients?.emails?.length === 1">
                  {{ (reminderRecipients?.emails)[0].value }}
                </span>

                <span *ngIf="reminderRecipients?.emails?.length !== 1">
                  <span *ngIf="!reminderRecipients?.emails?.length">No email</span>
                  <span *ngIf="reminderRecipients?.emails?.length"> {{ reminderRecipients?.emails?.length }} email
                    addresses </span>
                </span>
              </div>

              <div class="flex-start-center font-12">
                <i class="far fa-mobile font-gray-85 contact-icon flex-center-center"></i>
                <span *ngIf="reminderRecipients?.phones?.length === 1">
                  {{ (reminderRecipients?.phones)[0].value | mask : '(000) 000-0000' }}
                </span>

                <span *ngIf="reminderRecipients?.phones?.length !== 1">
                  <span *ngIf="!reminderRecipients?.phones?.length">No phone</span>
                  <span *ngIf="reminderRecipients?.phones?.length"> {{ reminderRecipients?.phones?.length }} mobile
                    numbers </span>
                </span>
              </div>

              <div class="ui-g-12 p-zero mt-1" *ngFor="let reminder of reminders; let i = index">
                <app-review-reminders *ngIf="serverTime" [currentDateTime]="serverTime" [showOrder]="false"
                  [reminder]="reminder" [index]="i + 1" [isTimeOpen]="i === 0" [sameLine]="false"
                  [dropDownPositionTop]="true" (deleteReminderItem)="deleteReminder($event)">
                </app-review-reminders>
              </div>
            </div>
          </div>
          <div *ngIf="templateType === 'INVOICE'" class="schedule-pickup-wrapper mt-2 pb-10">
            <app-switch-card [active]="isSchedulePickUp" [switch]="card.schedule.switch"
              [heading]="card.schedule.heading" [content]="card.schedule.content"
              [defaultSchedulePickUpState]="defaultSchedulePickUpState" [isSchedulePickUp]="isSchedulePickUp"
              [isFetching]="isFetching" [isDataLoading]="isDataLoading"
              (appChange)="toggleActiveState('isSchedulePickUp', $event)"
              (appUpdateSettings)="updateScheduleSettings($event)">
            </app-switch-card>

            <div class="flex-start-center">
              <div class="calendar-input" [ngClass]="{ disabled: !this.isSchedulePickUp }">
                <p-calendar placeholder="Time" appendTo="body" [minDate]="serverTime"
                  [disabled]="!this.isSchedulePickUp" [(ngModel)]="pickUpDate" dateFormat="M dd, yy"
                  (onSelect)="onDateTimeChange($event)"></p-calendar>
              </div>

              <div class="date-select" [ngClass]="{ disabled: !this.isSchedulePickUp }">
                <app-dropdown idKey="i" field="label" placeholder="Date" theme="border" scrollHeight="152px"
                  itemWidth="150px" hPosition="left" styleClassSelectedView="time-dropdown"
                  [disabled]="!this.isSchedulePickUp" styleClassDropdownList="time-box-shadow" styleClassDropdownList=""
                  [options]="times" [setPositionDynamically]="false" [fontSize]="13" [isInline]="true"
                  [value]="selectedTime" [focusOnSelectedValue]="true" [isDropdownIconVisible]="false"
                  (appSelect)="onSelectStartTime($event)">
                </app-dropdown>
              </div>
            </div>
          </div>

          <!-- Inspections -->
          <div class="notification-contact-box flex-column mt-2">
            <div class="flex-start-center pointer" (click)="toggleInspectionVisibilty()">
              <i class="inspection-dropdown-icon font-gray font-12 fal"
                [ngClass]="{ 'fa-chevron-down': isInspectionsVisible, 'fa-chevron-up': !isInspectionsVisible }"></i>

              <span class="font-600 font-14">Send&nbsp;inspection</span>
            </div>

            <div class="modal-checkbox" *ngIf="isInspectionsVisible">
              <div *ngFor="let service of order?.services" [hidden]="!service.includeInInvoice" class="mt-1">
                <app-checkbox *ngIf="service?.inspection?.inspectionId" [isChecked]="inspectionsStatus[service?._id]"
                  [fontSize]="12" [label]="service?.inspection?.inspectionId?.title || service?.inspection?.title"
                  (appChange)="handleInspectionChange(service?._id, $event)">
                </app-checkbox>
              </div>
            </div>
          </div>

          <!-- Attachments -->
          <div class="notification-contact-box flex-column mt-2">
            <div class="flex-start-center pointer" (click)="toggleAttachmentVisibilty()">
              <i class="inspection-dropdown-icon font-gray font-12 fal"
                [ngClass]="{ 'fa-chevron-down': isAttachmentsExpanded, 'fa-chevron-up': !isAttachmentsExpanded }"></i>

              <span class="font-600 font-14">Attachments&nbsp;(external)</span>
            </div>

            <div class="modal-checkbox attachment" *ngIf="isAttachmentsExpanded">
              <div class="mt-1 position-relative" *ngFor="let orderAttachment of orderAttachments">
                <div class="file-icon-wrapper"><i class="far fa-file-image"></i></div>
                <app-checkbox [fontSize]="12"
                  [isChecked]="order?.orderStatus === 'estimate' ? orderAttachment?.isVisibleOnEstimate : orderAttachment?.isVisibleOnInvoice"
                  (appChange)="handleAttachmentChange(orderAttachment, $event, order?.orderStatus === 'estimate' ? 'isVisibleOnEstimate' : 'isVisibleOnInvoice')"
                  label="{{ orderAttachment?.title + '.' + orderAttachment?.fileExtension }}">
                </app-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Right Panel -->

      <!-- Start Follow-up Section -->
      <div *ngIf="isMarketingEnabled" class="col-12 col-lg-{{ isMarketingEnabled ? '4' : '6' }} p-0">
        <app-dialog-follow-ups [isMarketingOptOutEnabled]="isMarketingOptOutEnabled" [estimate]="order"
          [sendEstimate]="order.sendEstimate" (appHasFollowUps)="hasFollowUps = $event">
        </app-dialog-follow-ups>
      </div>
      <!-- End Follow-up Section -->
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="ui-g-6 p-zero">
      <div class="customer-preview" (click)="preview()">Customer {{ title }} Preview</div>
    </div>

    <div class="ui-g-6 p-zero text-right">
      <input id="send-dialog-btn-cancel" type="button" (click)="close({})" value="Cancel"
        class="btn btn-white btn-border pointer btn-submit mr-1" />

      <button class="btn btn-primary btn-submit" [ngClass]="{ 'btn-secondary': isSent }"
        [disabled]="isProcessing || isSavingLanguage || isSent || (isEstimateDeposit && errors.depositAmt) || isFetching"
        (click)="onSubmit()">
        <span [ngClass]="{ 'pr-2': isProcessing || isFetching, 'not-allowed': isSent || isFetching }">{{ isSent ? 'Sent'
          : 'Send' }}</span>
        <i *ngIf="isProcessing || isFetching" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
